module.exports = __webpack_public_path__ + "static/assets/6de7ffa09679f0e412691e2626acf871.png";